import { createContext, useEffect, useState } from "react";
import GetLocalStorageValue from "./reusable/GetLocalStorageValue";
import { getSingleAccessibleProduct } from "./reusable/ProductAccess";

const UserContext = createContext({});

const UserContextProvider = ({ children }) => {
  const getSystemTheme = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches ? true : false;

  // const [darkTheme, setDarkTheme] = useState(false);
  const [darkTheme, setDarkTheme] = useState(() => getSystemTheme());

  const [isSmMenuOpen, setIsSmMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  // const [resToken, setResToken] = useState({});
  // const [resToken, setResToken] = useState({});
  const [resToken, setResToken] = useState("");
  const [userLoginInfo, setUserLoginInfo] = useState("");
  const [cnUserInfo, setCnUserInfo] = useState("");
  const [codeNavigatorToken, setCodeNavigatorToken] = useState("");
  const [tokenMode, setTokenMode] = useState("");

  const [allPosts, setAllPosts] = useState([]);
  const [bodyData, setBodyData] = useState({});
  const [postId, setPostId] = useState("");
  const [selectedHighlight, setSelectedHighlight] = useState(null);
  const [loginDataLoading, setLoginDataLoading] = useState(true);
  const [openMenu, setOpenMenu] = useState(null);
  const [breadCrumb, setBreadCrumb] = useState("");
  const [breadCrumbCategory, setBreadCrumbCategory] = useState("");

  const [urlTagIdStore, setUrlTagIdStore] = useState("");
  const [initialLeftScrollTrue, setInitialLeftScrollTrue] = useState(false);
  const [leftScrollFlag, setLeftScrollFlag] = useState(false);

  // profile toggle
  const [isProfileOpen, setIsProfileOpen] = useState(false);

  // const [slug4PrevBtn, setSlug4PrevBtn] = useState("");

  // openSource Link in askCN
  const [isOpenLink, setIsOpenLink] = useState("");
  // Date: 22 Oct 2026
  // Product ("codeNavigator" | "continuum") of the article an Open Document
  // link points at. Kept apart from `product` on purpose: that one is
  // persisted to localStorage and would carry over into the visitor's next
  // login.
  const [odProduct, setOdProduct] = useState("");

  // MSAL HANDLER VAR
  const [graphData, setGraphData] = useState(null);
  // Persisted to sessionStorage (not just in-memory) so an MSAL redirect
  // login -- which reloads the page -- doesn't lose track of being mid-login
  // and fall back to the normal (non-MSAL) route tree on return.
  const [isMsalLogin, setIsMsalLoginState] = useState(
    () => sessionStorage.getItem("isMsalLogin") === "true",
  );
  const setIsMsalLogin = (value) => {
    if (value) {
      sessionStorage.setItem("isMsalLogin", "true");
    } else {
      sessionStorage.removeItem("isMsalLogin");
    }
    setIsMsalLoginState(value);
  };

  // FOOTER HANDLER WHEN SCROLL THE PAGE
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [allowFeedback, setAllowFeedback] = useState(0);

  // Date: 15 Jan, 2025
  // Ref: Meeting for ask cn Versions control.
  // Changes: Added codes for version switching.
  // VERSION NAME SELECT
  const [versionName, setVersionName] = useState("");
  const [isVersionNameClicked, setIsVersionNameClicked] = useState(false);
  // const [isVersionNameClicked, setIsVersionNameClicked] = useState("notClick");
  const [versionNameInitialSlugSet, setVersionNameInitialSlugSet] =
    useState("");

  // POST LOADER --------
  // const [postLoader, setPostLoader] = useState(true);

  // Date: 28 Feb 2025
  // const [currentArticleAddrRefresh, setCurrentArticleAddrRefresh] = useState(false);

  // Date: 1 March 2025
  const [isVersionArticleNotFound, setIsVersionArticleNotFound] =
    useState(false);
  const [storeClickedVersion, setStoreClickedVersion] = useState("");

  // Date: 21 Jul 2026
  const [checkArticleLoader, setCheckArticleLoader] = useState(false);

  // Date: 7 Aug 2026
  // Ref: Continuum KB rollout.
  // Which KB product ("codeNavigator" | "continuum") the personal-login user has chosen,
  // persisted like tokenMode so the choice survives a refresh.
  const [product, setProductState] = useState(
    () => localStorage.getItem("product") || "",
  );
  const setProduct = (value) => {
    if (value) {
      localStorage.setItem("product", value);
    } else {
      localStorage.removeItem("product");
    }
    setProductState(value);
  };

  useEffect(() => {
    setLoginDataLoading(true);
    const accessToken = localStorage.getItem("access_token");
    const cnAccessToken = localStorage.getItem("cn_access_token");
    // setResToken(accessToken || "");
    // setCodeNavigatorToken(cnAccessToken || "");

    if (cnAccessToken) {
      setTokenMode("codenavigator");
      setUserLoginInfo("");

      // Date: 12 Dec, 2024
      // Ref: Email/Meeting on 11 Dec, 2024 from Manigandan to add cn Username and version.
      // Changes: Initialy Page load, Storing cn Username and version.
      const gettingCnUserInfoData = GetLocalStorageValue("cn_userInfo", {});
      setCnUserInfo(gettingCnUserInfoData);
    } else {
      setTokenMode("personal");
      // NORMAL LOGIN info
      const gettingLocalStorageData = GetLocalStorageValue("uInfo", {});
      setUserLoginInfo(gettingLocalStorageData);

      // Date: 11 Aug 2026
      // Ref: Covers a page refresh -- a fresh login sets this itself (see
      // Login.js/ProfileContent.js) since this mount effect won't re-run then.
      // Only auto-picks when no KB has been chosen yet, so a multi-access
      // user's earlier chooser pick is never overridden.
      if (!product) {
        const singleAccessProduct = getSingleAccessibleProduct(
          gettingLocalStorageData,
        );
        if (singleAccessProduct) {
          setProduct(singleAccessProduct);
        }
      }

      // MS LOGIN info
      const gettingLocalStorageMSData = GetLocalStorageValue("msInfo", {});
      setGraphData(gettingLocalStorageMSData);
    }

    if (!resToken || !codeNavigatorToken) {
      setLoginDataLoading(false);
    } else {
      setLoginDataLoading(false);
    }

    // localStorage.removeItem("previousUrl");
  }, []);

  // 7 Feb 2025
  const [removeGrid, setRemoveGrid] = useState("grid");
  const [leftBarHide, setleftBarHide] = useState("block");
  const [iconContentTitle, setIconContentTitle] = useState(
    "Close table of contents",
  );

  const collapseLeftBarFun = () => {
    setleftBarHide(leftBarHide === "block" ? "hidden" : "block");
    setRemoveGrid(removeGrid === "grid" ? "" : "grid");
    setIconContentTitle(
      iconContentTitle === "Close table of contents"
        ? "Open table of contents"
        : "Close table of contents",
    );
  };

  return (
    <UserContext.Provider
      value={{
        darkTheme,
        setDarkTheme,
        isSmMenuOpen,
        setIsSmMenuOpen,
        isSearchOpen,
        setIsSearchOpen,
        resToken,
        setResToken,
        allPosts,
        setAllPosts,
        bodyData,
        setBodyData,
        selectedHighlight,
        setSelectedHighlight,
        loginDataLoading,
        setLoginDataLoading,
        codeNavigatorToken,
        setCodeNavigatorToken,
        tokenMode,
        setTokenMode,
        openMenu,
        setOpenMenu,
        breadCrumb,
        setBreadCrumb,
        breadCrumbCategory,
        setBreadCrumbCategory,
        urlTagIdStore,
        setUrlTagIdStore,
        initialLeftScrollTrue,
        setInitialLeftScrollTrue,
        leftScrollFlag,
        setLeftScrollFlag,
        userLoginInfo,
        setUserLoginInfo,
        postId,
        setPostId,
        isProfileOpen,
        setIsProfileOpen,

        isOpenLink,
        setIsOpenLink,
        odProduct,
        setOdProduct,

        graphData,
        setGraphData,
        isMsalLogin,
        setIsMsalLogin,
        isFooterVisible,
        setIsFooterVisible,
        allowFeedback,
        setAllowFeedback,
        cnUserInfo,
        setCnUserInfo,
        versionName,
        setVersionName,
        isVersionNameClicked,
        setIsVersionNameClicked,
        // postLoader, setPostLoader,
        versionNameInitialSlugSet,
        setVersionNameInitialSlugSet,

        // 7 Feb 2025
        removeGrid,
        setRemoveGrid,
        leftBarHide,
        setleftBarHide,
        iconContentTitle,
        setIconContentTitle,
        collapseLeftBarFun,

        // currentArticleAddrRefresh, setCurrentArticleAddrRefresh,
        isVersionArticleNotFound,
        setIsVersionArticleNotFound,
        storeClickedVersion,
        setStoreClickedVersion,

        // VERSION CHANGE LOADER
        checkArticleLoader,
        setCheckArticleLoader,

        // KB product chooser (Continuum rollout)
        product,
        setProduct,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export { UserContext, UserContextProvider };
